// reservationService.js
import { reservationAPI } from './restaurantAPI';

const reservationService = {
  // Get all reservations
  async getAll(params = {}) {
    try {
      const response = await reservationAPI.getAll(params);
      console.log('Reservation API Response:', response);
      return response.data;
    } catch (error) {
      console.error('Error in reservationService.getAll:', error);
      throw error;
    }
  },

  // Get single reservation
  async get(id) {
    try {
      const response = await reservationAPI.getById(id);
      return response.data;
    } catch (error) {
      console.error('Error in reservationService.get:', error);
      throw error;
    }
  },

  // Create new reservation
  async create(data) {
    try {
      console.log('Creating reservation with data:', data);
      const response = await reservationAPI.create(data);
      return response.data;
    } catch (error) {
      console.error('Error in reservationService.create:', error);
      throw error;
    }
  },

  // Update reservation
  async update(id, data) {
    try {
      const response = await reservationAPI.update(id, data);
      return response.data;
    } catch (error) {
      console.error('Error in reservationService.update:', error);
      throw error;
    }
  },

  // Delete reservation
  async delete(id) {
    try {
      const response = await reservationAPI.delete(id);
      return response.data;
    } catch (error) {
      console.error('Error in reservationService.delete:', error);
      throw error;
    }
  },

  // Confirm reservation
  async confirm(id) {
    try {
      const response = await reservationAPI.update(id, { statut: 'confirmee' });
      return response.data;
    } catch (error) {
      console.error('Error in reservationService.confirm:', error);
      throw error;
    }
  },

  // Cancel reservation
  async cancel(id) {
    try {
      const response = await reservationAPI.update(id, { statut: 'annulee' });
      return response.data;
    } catch (error) {
      console.error('Error in reservationService.cancel:', error);
      throw error;
    }
  },

  // Check-in (convert to location)
  async checkIn(id) {
    try {
      // Note: Cette fonction devra probablement appeler un endpoint spécifique
      // pour convertir la réservation en location
      const response = await reservationAPI.update(id, { statut: 'en_cours' });
      return response.data;
    } catch (error) {
      console.error('Error in reservationService.checkIn:', error);
      throw error;
    }
  },

  // Get upcoming reservations
  async getUpcoming() {
    try {
      const today = new Date().toISOString().split('T')[0];
      const response = await reservationAPI.getAll({
        date_debut__gte: today,
        statut__in: ['en_attente', 'confirmee']
      });
      return response.data;
    } catch (error) {
      console.error('Error in reservationService.getUpcoming:', error);
      throw error;
    }
  },

  // Get today's arrivals
  async getTodayArrivals() {
    try {
      const today = new Date().toISOString().split('T')[0];
      const response = await reservationAPI.getAll({
        date_debut: today,
        statut: 'confirmee'
      });
      return response.data;
    } catch (error) {
      console.error('Error in reservationService.getTodayArrivals:', error);
      throw error;
    }
  }
};

export default reservationService;